export const GET_EMAILS_PENDING = 'GET_EMAILS_PENDING'
export const GET_EMAILS_SUCCESSFUL = 'GET_EMAILS_SUCCESSFUL'
export const GET_EMAILS_ERROR = 'GET_EMAILS_ERROR'
export const RECEIVE_EMAILS = 'RECEIVE_EMAILS'
export const CLEAR_EMAILS = 'CLEAR_EMAILS'
export const GET_EMAILS = 'GET_EMAILS'
export const EMAIL_SEARCH_LIMIT = 'EMAIL_SEARCH_LIMIT'
export const CHANGE_EMAIL_SEARCH_QUERY = 'CHANGE_EMAIL_SEARCH_QUERY'
export const SAVE_MESSAGE_PENDING = 'SAVE_MESSAGE_PENDING'
export const SAVE_MESSAGE_SUCCESSFUL = 'SAVE_MESSAGE_SUCCESSFUL'